import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Ng2SmartTableModule } from 'ng2-smart-table';
import { CKEditorModule } from 'ngx-ckeditor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { UsersRoutingModule } from './users-routing.module';
import { EditPersonalDataComponent } from './edit-personal-data/edit-personal-data.component';
import { FinalClientElectricityComponent } from './electricity/final-client-electricity.component';
import { FinalClientGasComponent } from './gas/final-client-gas.component';

import 'hammerjs';
import 'mousetrap';
import { EditPersonalDataService } from './services/edit-personal-data.service';
import { GasConsumptionPlaceDetailsComponent } from './gas/details/consumption-place/gas-consumption-place-details.component';
import { ElectricityConsumptionPlaceDetailsComponent } from './electricity/details/consumption-place/electricity-consumption-place-details.component';

import { FinalClientService } from './services/final-client.service';
import { PublicModule } from 'src/app/public/public.module';
import { SignaturePadModule } from 'angular2-signaturepad';

import { FinalClientNotificationsComponent } from './notifications/final-client-notifications.component';
import { FinalClientNotificationsService } from './services/final-client-notifications.service';
import { CompanyModule } from '../company/company.module';
import { SharedModule } from '../../shared/shared.module';
import { SupplierModule } from '../supplier/supplier.module';
import {ViewPersonalDataComponent} from "./view-personal-data/view-personal-data.component";

@NgModule({
  declarations: [
    EditPersonalDataComponent,
    ViewPersonalDataComponent,
    FinalClientElectricityComponent,
    FinalClientGasComponent,
    GasConsumptionPlaceDetailsComponent,
    ElectricityConsumptionPlaceDetailsComponent,
    FinalClientNotificationsComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    Ng2SmartTableModule,
    ReactiveFormsModule,
    UsersRoutingModule,
    CKEditorModule,
    FormsModule,
    PublicModule,
    SupplierModule,
    SignaturePadModule,
    CompanyModule,
    SharedModule
  ],
  providers: [
    EditPersonalDataService,
    FinalClientService,
    FinalClientNotificationsService
  ],
  exports: [
    EditPersonalDataComponent,
    FinalClientElectricityComponent,
    FinalClientGasComponent,
    GasConsumptionPlaceDetailsComponent,
    ElectricityConsumptionPlaceDetailsComponent,
    FinalClientNotificationsComponent,
    ViewPersonalDataComponent
  ]
})
export class UsersModule {
}
